import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import { Button } from 'react-bootstrap';
import ConfirmButton from '../../../../../components/confirm-button';


class CancelOutreachRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    this.cancelOutreach = this.cancelOutreach.bind(this);
  }
 
  cancelOutreach() {
    this.props.requestCancel(this.props.data);
  }
  renderContent() {
    const { value } = this.props;
    const isActive = value === 'ACTIVE';
    if (!isActive) {
      return (<span className="text-danger">{value}</span>);
    }

    return (
      <Button
        bsStyle="danger"
        onClick={this.cancelOutreach}
        bsSize="xs"
        style={{ marginBottom: 4 }}
      >
        <span>Cancel</span>
      </Button>
    );
  }
  render() {
    const isGrouped = this.props.node && this.props.node.group;
    if (!isGrouped) {
      return this.renderContent();
    }
    return null;
  }
}

CancelOutreachRenderer.propTypes = {
  value: PropTypes.string,
  data: PropTypes.shape({
    id: PropTypes.string,
  }),
  node: PropTypes.shape({
    group: PropTypes.bool,
  }),
  requestCancel: PropTypes.func,
};
CancelOutreachRenderer.defaultProps = {
  node: null,
  data: null,
  requestCancel: () => Promise.reject('Missing hanlder'),
};

export default CancelOutreachRenderer;
